import { useCallback, useEffect } from "react"
import { useAtom } from "@reatom/npm-react"

import { PsyCard } from "modules/PsyCatalog/common"
import { Spinner } from "components/Spinner"
import {
    loadingAtom,
    searchRequestResultAtom,
} from "modules/PsyCatalog/common/models/searchRequest"
import { paginationAtom } from "modules/PsyCatalog/common/models/pagination"
import { Pagination } from "modules/PsyCatalog/browser-side/Pagination"
import { Banner } from "modules/PsyCatalog/browser-side/ManualSelection/Banner"

export function PsySearchResults() {
    const [loadingStatus] = useAtom(loadingAtom)
    const [searchResults] = useAtom(searchRequestResultAtom)
    const [{ currentPage }] = useAtom(paginationAtom)

    const getPosition = useCallback<(index: number) => string>(
        (index) => `${index + 1 + PAGE_SIZE * (currentPage - 1)}`,
        [currentPage]
    )
    useEffect(() => {
        if (loadingStatus === "success" && !Banner.canBeShown()) {
            document.querySelector(".psychologist-list")?.scrollIntoView({ behavior: "smooth" })
        }
    }, [loadingStatus])

    return (
        <main className="main">
            {loadingStatus === "loading" ? (
                <Spinner />
            ) : (
                <>
                    <section className="psychologist-list">
                        {searchResults.profiles.map((psy, index) => (
                            <PsyCard position={getPosition(index)} key={psy.hash_id} psy={psy} />
                        ))}
                    </section>
                </>
            )}
            <Pagination />
        </main>
    )
}

export const PAGE_SIZE = 6
